import React, { useState, useEffect, useRef } from "react";
import { Lightbulb, X, ExternalLink } from "lucide-react";
import * as api from "../../lib/api";

export default function KBSuggestions({ title, ticketType, onViewArticle }) {
    const [suggestions, setSuggestions] = useState([]);
    const [dismissed, setDismissed] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => {
        if (dismissed || !title || title.length < 3 || !ticketType) {
            setSuggestions([]);
            return;
        }
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(async () => {
            try {
                const data = await api.searchKBArticles(title, ticketType);
                setSuggestions(data.slice(0, 3));
            } catch {
                setSuggestions([]);
            }
        }, 500);
        return () => { if (timerRef.current) clearTimeout(timerRef.current); };
    }, [title, ticketType, dismissed]);

    if (dismissed || suggestions.length === 0) return null;

    return (
        <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg" data-testid="kb-suggestions-banner">
            <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2 text-amber-800">
                    <Lightbulb className="w-4 h-4 flex-shrink-0" />
                    <span className="text-xs font-medium">Avant de soumettre, ces articles peuvent vous aider :</span>
                </div>
                <button
                    onClick={() => setDismissed(true)}
                    className="text-amber-400 hover:text-amber-600 p-0.5"
                    data-testid="kb-suggestions-dismiss"
                >
                    <X className="w-3.5 h-3.5" />
                </button>
            </div>
            <div className="space-y-1.5 ml-6">
                {suggestions.map((article) => (
                    <a
                        key={article.id}
                        href={`/base-de-connaissances`}
                        onClick={(e) => {
                            e.preventDefault();
                            if (onViewArticle) onViewArticle(article.id);
                            else window.open(`/base-de-connaissances`, "_blank");
                        }}
                        className="flex items-center gap-2 text-xs text-amber-900 hover:text-amber-700 transition-colors group"
                        data-testid={`kb-suggestion-${article.id}`}
                    >
                        <span className="text-amber-400">→</span>
                        <span className="group-hover:underline">{article.title}</span>
                        <ExternalLink className="w-3 h-3 text-amber-400 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </a>
                ))}
            </div>
        </div>
    );
}
